class WebPushNotificationManager {
    private vapidKey = 'BEhCK8iaOS8h5bfsDzGPgqZFr_arJxeDdZ1s6HmAVoQblnXSiE62U741r8uWMGyGvgJMhGepAkfKWL3-S6jUuJI';

    private async getRegistration(): Promise<ServiceWorkerRegistration | null> {
        if (!('serviceWorker' in navigator)) {
            return null;
        }
        const registrations = await navigator.serviceWorker.getRegistrations();
        return registrations.find((x) => x.active?.scriptURL.includes('sw.js')) ?? null;
    }

    public async hasValidRegistration(): Promise<boolean> {
        return (await this.getRegistration()) != null;
    }

    public async hasPermission(): Promise<boolean> {
        return (await Notification.permission) === 'granted';
    }

    public async getSubscription(): Promise<PushSubscription | null> {
        const registrations = await navigator.serviceWorker.getRegistrations();
        if (registrations.length == 0) {
            return null;
        }
        return await registrations[0].pushManager.getSubscription();
    }

    public async registerServiceWorker() {
        if (!('serviceWorker' in navigator)) {
            throw new Error('Service workers are not supported in this browser.');
        }
        const notificationVersion = (window as any).NotificationVersion as number;
        const registrations = await navigator.serviceWorker.getRegistrations();
        const activeRegistration = registrations.find((x) => x.active?.scriptURL.includes('sw.js'));
        if (activeRegistration && activeRegistration.active) {
            const url = new URL(activeRegistration.active.scriptURL);
            const queryParams = new URLSearchParams(url.search);
            const value = queryParams.get('v');
            if (value && value !== notificationVersion.toString()) {
                console.log('Updating service worker');
                await activeRegistration.update();
            }
            return activeRegistration;
        } else {
            console.log('Registering new service worker');
            return await navigator.serviceWorker.register('/sw.js', { scope: '/' });
        }
    }

    private async requestNotificationPermission() {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            throw new Error('Permission not granted for push notifications');
        }
    }

    public async unregister() {
        const registrations = await navigator.serviceWorker.getRegistrations();
        if (registrations.length == 0) {
            return;
        }
        const subscription = await registrations[0].pushManager.getSubscription();
        if (subscription) {
            await subscription.unsubscribe();
        }
    }

    private async subscribeUserToPush(registration: ServiceWorkerRegistration) {
        const pushSubscription = await registration.pushManager.getSubscription();
        if (pushSubscription) {
            return pushSubscription;
        }
        return await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.urlB64ToUint8Array(this.vapidKey),
        });
    }

    private urlB64ToUint8Array(base64String: string) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    public async register(): Promise<PushSubscription | null> {
        try {
            const registration = await this.registerServiceWorker();
            console.log('Service Worker registered with scope:', registration.scope);

            await this.requestNotificationPermission();

            return await this.subscribeUserToPush(registration);
        } catch (error) {
            console.error('Error during registration process:', error);
            return null;
        }
    }

    public async postMessage(data: any) {
        const registration = await this.getRegistration();
        if (registration && registration.active) {
            registration.active.postMessage(data);
        }
    }
}

const notificationManager = new WebPushNotificationManager();
export default notificationManager;
